import { render, staticRenderFns } from "./blog6.vue?vue&type=template&id=c1643654"
import script from "./blog6.vue?vue&type=script&lang=js"
export * from "./blog6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports